<template>
  <div>
    <table v-if="hasDiffs" class="mergeTable" width="100%">
        <thead>
        <tr>
          <th align="center" width="33%" style="padding-right: 5px;"><a @click="res = JSON.parse(JSON.stringify(o))">Старое</a></th>
          <th align="center" width="34%" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;"> ← diff →</th>
          <th align="center" width="33%" style="padding-left: 5px;"><a @click="res = JSON.parse(JSON.stringify(n))">Новое</a></th>
        </tr>
        </thead>
        <tbody v-for="(eee,index) in maxCount">
        <tr>
          <td v-if="oToText[index]"  :class="{'selected': resToText[index] === oToText[index]}" valign="top" style="padding-right: 5px;">
            <a @click="setRes(index, 'old')">{{ oToText[index] }}</a>
          </td>
          <td v-else  valign="top" style="padding-right: 5px;"> <a @click="res.splice(index,1)">X</a></td>
          <td valign="top" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;">
            <span class="diff" v-html="getDiff(index)"/>
          </td>
          <td v-if="nToText[index]"  :class="{'selected': resToText[index] === nToText[index] && nToText[index] !== oToText[index]}" valign="top" style="padding-left: 5px;">
            <a @click="setRes(index, 'new')">{{ nToText[index]}}</a>
          </td>
          <td v-else  valign="top" style="padding-right: 5px;"> <a @click="res.splice(index,1)">X</a></td>
        </tr>
        </tbody>
    </table>
    <table class="mergeTable" width="100%">
      <thead>
      <tr>
        <th align="center" colspan="100%">Актуальное</th>
      </tr>
      </thead>
      <tbody v-for="(row, certRowIndex) in res" class="hover">
      <tr style="height: 31px">
        <td valign="top" colspan="100%" class="selected">
          <input type="text"
                 ref="cert"
                 v-model="row.univercity"
                 @paste="onPasteCertificates(certRowIndex, $event)"
                 class="certificateName"
                 v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'"
                 placeholder="Название курса или сертификата">
        </td>
        </tr>
      <tr style="height: 31px">
        <td class="selected" colspan="100%">
                            <span class="certificateYearBlock" v-for="(y,i) in row.year" track-by="$index">

                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{numeric:true, min_value:1900, max_value:currentYear}"
                                >
                                    <input v-model="row.year[i]" @keyup="inputCertificateYear(certRowIndex)"
                                           @click.prevent="inputCertificateYear(certRowIndex)" placeholder="Год"
                                           type="number"
                                           min="1900" :max="currentYear" v-units.literal="`г`"
                                           style="width: 70px; text-align: left !important;"
                                           @blur="arrangeCertificates"

                                           :class="{'hasError' : errors[0]}"
                                           v-tooltip="{
                                               content: errors[0],
                                               template: $errTemplate,
                                            }"
                                    >
                                </ValidationProvider>
                                <button class="small redHover square"
                                        @click.prevent="removeCertificateYear(certRowIndex, i)" tabindex="-1"><i
                                    class="far fa-trash-can"></i></button>
                            </span>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr style="height: 38px;">
        <td colspan="100%" style="text-align: center;">
          <button class="small addCertificate" @click.prevent="addCertificate(true)" tabindex="-1">
              Добавить курс или сертификат
          </button>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
import Base from "../Base.vue";
import DiffMatchPatch from 'diff-match-patch';
import _ from "lodash";
export default {
    mixins:[Base],
    props: {
      o: {
        type: [Array],
        default: ''
      },
      n: {
        type: [Array],
        default: ''
      },
      f: {
        type: [Array],
        default: ''
      },
    },
    data: function () {
        return {
          resToText: []
        }
    },
  created() {
    for (let i = 0; i < this.res.length; i++) {
      this.inputCertificateYear(i);
    }

    this.resToText = this.res.map( (item) => item.univercity + ' ' + item.year.join(' '));
  },
  methods: {

      setRes(index, type) {
        if (type === 'old') {
          this.res.splice(index, 1, JSON.parse(JSON.stringify(this.o[index])));
        }
        if (type === 'new') {
          this.res.splice(index, 1, JSON.parse(JSON.stringify(this.n[index])));
        }
      },
    addCertificate (focus) {
        this.res.push({univercity: '', year: ['']});
      },
    addCertificateYear(certIndex) {
      this.res[certIndex].year.push("");
    },
    removeCertificate (index) {
      this.res.splice(index, 1);
    },
    removeCertificateYear (certIndex, index) {
      if (this.res[certIndex].year.length === 1) {
        if (_.isEmpty(this.res[certIndex].univercity.trim())) {
          this.removeCertificate(certIndex);
        } else {
          if (confirm('Удалить всю запись о курсе/сертификате "' + this.res[certIndex].univercity + '"?')) {
            this.removeCertificate(certIndex);
          }
        }
      } else
        this.res[certIndex].year.splice(index, 1);
    },
    onPasteCertificates (index, e) {
      let input = this.$refs.cert[index];
      let text = e.clipboardData.getData('text/plain');

      if (input.value) {
        let newText = input.value.substring(0, input.selectionStart) + text + input.value.substring(input.selectionEnd);
        this.res[index].univercity = _.upperFirst(newText.split('\n').join(' ').trim());
      } else {
        this.textToCertificates(text, index);
      }

      e.preventDefault();

      this.inputCertificate();
    },
    inputCertificateYear (certIndex) {

      let lastYearIndex = this.res[certIndex].year.length - 1;

      if ((this.res[certIndex].year.length === 0) || (this.res[certIndex].year[lastYearIndex] !== '')) {
        this.addCertificateYear(certIndex);
      }
    },
    arrangeCertificates: function () {
      for (const [key, certificateGroup] of Object.entries(this.res)) {
        let orderedYears = certificateGroup.year.filter(year => year !== '').sort();
        this.res[key].year = orderedYears.concat('');
      }
    },
    textToCertificates (line, index) {
      line = line.split('\n').join(' ').trim();
      if (!_.isEmpty(line)) {
        let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
          let y = parseInt(val);
          if ((1970 <= y && y <= 2030)) {
            acc.push('' + y);
            return acc;
          } else if ((70 <= y && y <= 99)) {
            acc.push('' + (1900 + y));
            return acc;
          }
          return acc;
        }, []);

        if (index === null) {
          if (
            !!(this.res[this.res.length - 1]) &&
            _.isEmpty(this.res[this.res.length - 1].univercity) &&
            _.isEmpty(this.res[this.res.length - 1].year[0])
          ) {
            this.res = this.res.slice(0, -1);
          }

          this.res.push({
            univercity: this.cutLastComma(_.upperFirst(line).trim()),
            year:       year
          });
        } else {
          this.res.splice(index, 1, {
            univercity: this.cutLastComma(_.upperFirst(line).trim()),
            year:       year
          });
        }
      }
      for (var i = 0; i < this.res.length; i++) {
        this.inputCertificateYear(i);
      }
    },
    getDiff(index) {
        let dmp = new DiffMatchPatch();
        let d = dmp.diff_main(this.oToText[index] ?? '',this.nToText[index] ?? '');
        dmp.diff_cleanupEfficiency(d);
        return dmp.diff_prettyHtml(d);
    },
    inputCertificate() {
      if (!_.last(this.res) || _.last(this.res) && _.last(this.res).univercity !== '') {
        this.addCertificate();
      }
    },
    cutLastComma(text) {
      if (text[text.length - 1] === ',') {
        text = text.slice(0, text.length - 1);
      }

      return text;
    },
  },
  watch: {
    res: {
      deep: true,
      handler: function(value) {
        this.resToText = value.map( (item) => item.univercity+ ' ' +item.year.join(' '));
      }
    },
  },
  computed: {
      hasDiffs () {
        return !_.isEqual(this.o, this.n)
      },
      currentYear () {
        return new Date().getFullYear() ?? 2400;
      },
      oToText () {
        return this.o.map( (item) => item.univercity+ ' ' +item.year.join(' '))
      },
      nToText () {
        return this.n.map( (item) => item.univercity+ ' ' +item.year.join(' '))
      },
      maxCount () {
        return Math.max(this.oToText.length,this.nToText.length)
      },
    }
}
</script>
<style>
.certificateYearBlock {
  margin-right: 5px;
}
</style>
